import { staticReducers as coreStaticReducers } from '@core/js/store/staticReducers';
import * as Types from '@core/js/store/types';

import { reducer as bingoScheduleReducer } from '@interlayer/js/custom/components/main/BingoScheduler/store/reducer';
import { REDUCER_NAMES } from '@interlayer/js/custom/stores/constants';
import { reducer as customUserReducer } from '@interlayer/js/custom/stores/user/reducer';

export const staticReducers = {
    ...coreStaticReducers,
    [REDUCER_NAMES.CUSTOM_USER_REDUCER]: customUserReducer,
    [REDUCER_NAMES.BINGO_SCHEDULE_REDUCER]: bingoScheduleReducer as Types.TCommonReducer
};
